<div class="logo" [ngClass]="{'logo-inline': mode==='vertical'}">
  <a routerLink="/layout">
<!--    <img src="https://ng.ant.design/assets/img/logo.svg"/>-->
<!--        <img src="assets/imgs/icon.png" />-->
    <h1>雅培ADC</h1>
  </a>
</div>
<nzo-levels-menu class="levels-menu" [menus]="menus" theme="dark" [mode]="mode" [selected]="selectedUrl"
                 [inlineCollapsed]="collapsed" [class.nzo-menu]="mode==='vertical'">
</nzo-levels-menu>
